module.exports = __webpack_public_path__ + "static/img/tit-bar.be700f75.webp";